import useConcent from '../core/hook/use-concent';

export default useConcent;
